import { useBoolean, useEventCallback } from "usehooks-ts";

import { ConfirmDialog, ConfirmDialogProps } from "@/components/ui-v2";

type UseConfirmDialogProps = {
  title: string;
  description: string;
  onConfirm: () => void;
  confirmDialogProps?: Omit<
    ConfirmDialogProps,
    "open" | "title" | "description" | "onConfirm" | "onClose"
  >;
};

export const useConfirmDialog = (props: UseConfirmDialogProps) => {
  const { title, description, onConfirm, confirmDialogProps } = props;

  const {
    value: isDialogOpen,
    setTrue: openDialog,
    setFalse: closeDialog,
  } = useBoolean();

  const handleConfirm = useEventCallback(() => {
    onConfirm();
    closeDialog();
  });

  const handleClose = useEventCallback(() => {
    closeDialog();
  });

  const Element = (
    <ConfirmDialog
      {...confirmDialogProps}
      open={isDialogOpen}
      title={title}
      description={description}
      onConfirm={handleConfirm}
      onClose={handleClose}
    />
  );
  return {
    Element,
    isDialogOpen,
    openDialog,
    closeDialog,
  };
};
